<template>
  <div>
    <li
      class="sort-item"
      v-for="(option, index) in options"
      :key="index"
      v-show="!ques.referFlag || option.display"
      @click="handleSelect($event)"
    >
      <span ref="span" class="default-box"></span>
      <span class="default-box" style="visibility: hidden"></span>
      <div class="option-text">{{option.text}}</div>
    </li>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentIndex: 0,
      count: 0
    }
  },

  props: ['ques'],
  computed: {
    options() {
      return this.ques.options
    }
  },
  methods: {
    handleSelect(e) {
      let spanEle = e.currentTarget.children[0]
      let textEle = e.currentTarget.children[2]
      let index = ''
      if (!spanEle.innerText) {
        this.currentIndex++
        index = this.currentIndex
        spanEle.classList = 'default-box sorted-box'
        textEle.classList = 'option-text sorted-option-text'
      } else {
        this.currentIndex--
        spanEle.classList = 'default-box'
        textEle.classList = 'option-text'
        let spanEles = this.$refs['span']
        spanEles.forEach(ele => {
          if (+ele.innerText > +spanEle.innerText) {
            ele.innerText = +ele.innerText - 1
          }
        })
      }
      spanEle.innerText = index
      this.sortEnd()
    },
    sortEnd() {
      if (this.currentIndex != this.options.length) return
      let spanEles = this.$refs['span']
      spanEles.forEach((ele, i) => {
        let opt = this.options[i]
        opt.sortNo = +ele.innerText
      })
      this.$emit('end', this.ques)
    }
  }
}
</script>

<style scoped>
.sort-item {
  list-style: none;
  min-height: 30px;
  line-height: 20px;
  position: relative;
  color: #555;
}
.default-box {
  box-sizing: border-box;
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  text-align: center;
  background-color: #fff;
  color: #fff;
  transform: scale(0.7);
  position: relative;
  top: 5px;
}
.sorted-box {
  background-color: #ff552e;
  border: none;
  top: 0;
}
.option-text {
  line-height: 20px;
  position: relative;
  top: -20px;
  left: 30px;
  display: inline-block;
  width: calc(100% - 30px);
}
.sorted-option-text {
  color: #ff552e;
}
.warn {
  margin: 0;
  padding: 0;
  color: #ff552e;
}
@media screen and (max-width: 468px) {
  .option-text {
    font-size: 0.7rem;
  }
  .sorted-box {
    font-size: 0.7rem;
  }
  .default-box {
    width: 1rem;
    height: 1rem;
    line-height: 1rem;
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sort.vue